<template>
  <div>
      <div class="main">
          <div class="heard">
              个人资料
          </div>
          <div class="conter">
              <div class="subheader">
                我的银行卡 &nbsp;&nbsp;&nbsp;&nbsp;<span><span style="color:#62A3FF;cursor: pointer;" @click="setbankcode()">{{bankbuttontext}}</span></span>
              </div>
              <div class="bankinfopanel">
              <div class="bankinfo">
              <el-form :label-position="labelPosition" label-width="100px" :model="formLabelAlign">
                <el-form-item label="代理ID：" >
                  <el-input v-model="formLabelAlign.name" disabled=""  size="small"></el-input>
                </el-form-item>
                <el-form-item label="手机号码：" v-show="insTestProp.AgentRelyPhone">
                  <el-input v-model="formLabelAlign.bindphone" disabled=""  size="small"></el-input>
                  <div class="formrightbox">
                          <!-- <el-button class="formbtn" size="mini">解绑</el-button> -->
                          <el-button class="formbtn" size="mini" @click="setphone()">{{phoneinfo}}</el-button>
                          <!-- <el-button type="primary" icon="el-icon-edit" size="mini"></el-button> -->
                  </div>
                </el-form-item>
                <el-form-item label="身份证号：">
                  <el-input v-model="formLabelAlign.IDCardNo" disabled=""  size="small"></el-input>
                   <div class="formrightbox formrightboxb">
                          <el-button class="formbtn " size="mini" v-show="show" @click="setpersonid()">绑定</el-button>
                  </div> 
                </el-form-item>
                <el-form-item label="银行卡号：">
                  <el-input v-model="formLabelAlign.bankid" disabled=""  size="small"></el-input>
                </el-form-item>
                <el-form-item label="开户行：">
                  <el-input v-model="formLabelAlign.SubbranchName" disabled=""  size="small"></el-input>
                </el-form-item>
              </el-form>
            </div></div>
            <div class="bankinfopanel" v-show="insTestProp.EnabledUsdt">
              <div class="subheader">
                我的USDT钱包&nbsp;&nbsp;&nbsp;&nbsp;<span><a href="#" @click="setusdtaccount()">{{usdtbuttontext}}</a></span>
              </div>
              <div class="usdtinfo">
              <el-form :label-position="labelPosition" label-width="100px" :model="formLabelAlign">
              <el-form-item label="钱包种类：">
                  <el-input v-model="formLabelAlign.UsdtAccountType" disabled=""  placeholder="" ></el-input>
                </el-form-item>
              <el-form-item label="钱包账户：">
                  <el-input v-model="formLabelAlign.UsdtAccount" disabled=""  placeholder="请输入usdt钱包收款地址" onkeyup="this.value=this.value.replace(/\s+/g,'')"></el-input>
                </el-form-item>
                <el-form-item label="二维码：" class="phone_code">
                  <img id="usdtqrcodeImg" v-if="formLabelAlign.UsdtQrCodePath" :src="formLabelAlign.UsdtQrCodePath" class="avatar">
                </el-form-item>
                </el-form>
                </div></div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  name: "personaldata",
  data() {
    return {
      bankbuttontext:"点击修改",
      usdtbuttontext:"点击修改",
      show:"",
      labelPosition: "right",
      phoneinfo:"",
      formLabelAlign: {
        name: "",
        bindphone: "",
        IDCardNo: "",
        bankid: "",
        SubbranchName: "",
        UsdtAccountType:"",
        UsdtAccount:"",
        UsdtQrCodePath:""
      },
      isShowPhone: true,
      insTestProp: {
        IsTestIns: true, // 是否测试机构，true测试机构
        AgentRelyPhone: true, // 依赖手机号
        UseCustomId: true, // 使用自定义ID,false表示使用系统自动生成，true表示使用自定义ID
        EnabledUsdt: false
       },
	   isShowIdCard:true
    };
  },
  updated() {
  },
  created() {
    if (sessionStorage.getItem('isShowPhone') !== 'undefined' && sessionStorage.getItem('isShowPhone') !== '') {
      this.isShowPhone = JSON.parse(sessionStorage.getItem('isShowPhone'));
    }
		if (sessionStorage.getItem('isShowIdCard') !== 'undefined' && sessionStorage.getItem('isShowIdCard') !== '') {
		  this.isShowIdCard = JSON.parse(sessionStorage.getItem('isShowIdCard'));
		}
    this.formLabelAlign.name = sessionStorage.getItem("uname");
    this.insTestProp = JSON.parse(sessionStorage.getItem("insTestProp"));
    this.getpersonid();
    if (this.insTestProp.AgentRelyPhone) {
      this.getphone();
    }
    this.getbankcode();
    this.getusdtaccount();
    // setTimeout(() => {
    //   this.open();
    // }, 400)
  },
  methods: {
    getphone() {
      let url = "/Account/GetUserInfo";
      this.$loginapi.post(
        url,
        this.$store.state.userInfo.UserCode,
        response => {
          if (response.Ret == 0) {
           if (response.Data.BindPhone == null ||  response.Data.BindPhone == "" ){
                this.formLabelAlign.bindphone = "未绑定手机号，请绑定！"
                this.phoneinfo = "绑定"
          }else{
            this.phoneinfo = "修改"
             this.formLabelAlign.bindphone = response.Data.BindPhone;
             this.formLabelAlign.bindphone = this.formLabelAlign.bindphone.replace(/(\d{3})\d{4}(\d{4})/,"$1****$2");
             if (!this.isShowPhone) {
               this.formLabelAlign.bindphone = "***********";
             }
          }
          } else {
            this.$message.error(response.Msg);
          }
        }
      );
    },
    // 获取身份证号
    getpersonid() {
       let infodata = {
        // InsCode: this.$store.state.userInfo.InsCode,
        // UserCode: this.$store.state.userInfo.UserCode,
        // UserType: this.$store.state.userInfo.UserType,
        WithImg:false
      };
      let url = "/RealNameAuth/IsAuthed";
      this.$loginapi.post(url, infodata, response => {
        if (response.Ret == 0) {
          if (response.Data.Result == 0) {
            this.formLabelAlign.IDCardNo = "未实名认证！"
            this.show = true;
          }
          if (response.Data.Result == 1) {
            let url = "/RealNameAuth/GetInfoForMan";
            this.$loginapi.post(url, infodata, response => {
              if (response.Ret == 0) {
                this.formLabelAlign.IDCardNo = response.Data.IDCardNo;
				
				if(!!this.isShowIdCard){
					this.formLabelAlign.IDCardNo = this.formLabelAlign.IDCardNo.replace(/(\d{3})\d{11}(\d{4})/,"$1***********$2");
				}else{
					this.formLabelAlign.IDCardNo = "**********************";
				}
                 
              } else {
                // this.$message.error(response.Msg);
              }
            });
          }
          if (response.Data.Result == 2) {
           this.formLabelAlign.IDCardNo = "认证中，请等待审核！"
          }
           if (response.Data.Result == 3) {
            this.formLabelAlign.IDCardNo = "认证失败，请重新认证！"
              this.show = true;
          }
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    // 获取银行卡号
    getbankcode() {
      let url = "/Account/QueryBankCards";
      let This = this;
      this.$loginapi.post(url, "", response => {
        if (response.Ret == 0) {
           if (response.Data == null ||  response.Data == "" ){
                 this.formLabelAlign.bankid = "未绑定银行卡，请绑定！"
                 this.bankbuttontext = "点击绑定"

          }else{
            this.formLabelAlign.SubbranchName = response.Data[0].SubbranchName;
             this.formLabelAlign.bankid = response.Data[0].CardNO;
            //   this.formLabelAlign.bankid = this.formLabelAlign.bankid.substr(0, 4) + "********" + this.formLabelAlign.bankid.substr(-4);
               this.bankbuttontext = "";
          }
        } else {
        }
      });
    },
    // 获取usdt账号
    getusdtaccount() {
      let url = "/Account/QueryUsdtAccounts";
      let This = this;
      this.$loginapi.post(url, "", response => {
        if (response.Ret == 0) {
           if (response.Data == null ||  response.Data == "" ){
                 this.formLabelAlign.UsdtAccount = "未设置USDT账户！"
                 this.usdtbuttontext = "点击绑定"

          }else{
            this.formLabelAlign.UsdtAccountType = response.Data[0].AccountType;
              this.formLabelAlign.UsdtAccount = response.Data[0].AccountNO;
              this.formLabelAlign.UsdtQrCodePath = response.Data[0].QrCodePath;
               this.usdtbuttontext = "点击修改";
          }
        } else {
        }
      });
    },
        // 跳转弹框
    // open() {
    //   if (
    //     this.formLabelAlign.IDCardNo == "" ||
    //     this.formLabelAlign.IDCardNo == null
    //   ) {
    //     this.$alert("账户未绑定银行卡，请先绑定银行卡！", "", {
    //       confirmButtonText: "确定",
    //       callback: action => {
    //         this.$router.push("/modification/bankcode");
    //       }
    //     });
    //   } else if (
    //     this.formLabelAlign.bankid == "" ||
    //     this.formLabelAlign.bankid == null
    //   ) {
    //     this.$alert("账户未实名认证，请先实名认证！", "", {
    //       confirmButtonText: "确定",
    //       callback: action => {
    //         this.$router.push("/modification/personid");
    //       }
    //     });
    //   } else if (
    //     this.formLabelAlign.bindphone == "" ||
    //     this.formLabelAlign.bindphone == null
    //   ) {
    //     this.$alert("账户未绑定手机号，请先绑定手机号！", "", {
    //       confirmButtonText: "确定",
    //       callback: action => {
    //         this.$router.push("/modification/phone");
    //       }
    //     });
    //   }
    // },
    setphone() {
      this.$router.push("/modification/phone");
    },
    setpersonid() {
      this.$router.push("/modification/personid");
    },
    setbankcode() {
      this.$router.push("/modification/bankcode");
    },
    setusdtaccount() {
      this.$router.push("/modification/usdtaccount");
    }
  }
};
</script>

<style scoped>
.formrightbox{
    display: inline-block;
    position: absolute;
    margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/personaldata.vue